import legacyTranslate from '../../legacy/locales/translate'

const translate = legacyTranslate

export { translate }
